export default __webpack_public_path__ + "static/media/blobLeft.8875f03c.png";